export const setBasicDefaultStyles = (selectedTemplate, dispatch, actions, bgColors) => {
  const colors = bgColors?.length ? [...Object.values(bgColors)] : [];

  if (selectedTemplate >= 7 || selectedTemplate === 4 || selectedTemplate < 3 || selectedTemplate === 6) {
    dispatch(actions.setBackgroundColor(colors));
  }

  // if (selectedTemplate > 7) {
  //   dispatch(actions.setBasicInformation({ field: 'h1', value: LIST_OF_LINKS_MOCK_TEXT.H1_SHORT_TEXT }));
  //   dispatch(actions.setBasicInformation({ field: 'h2', value: LIST_OF_LINKS_MOCK_TEXT.H2_SHORT_TEXT }));
  // }

  // if (selectedTemplate <= 7) {
  //   dispatch(actions.setBasicInformation({ field: 'h1', value: LIST_OF_LINKS_MOCK_TEXT.H1_FULL_TEXT }));
  //   dispatch(
  //     actions.setBasicInformation({
  //       field: 'h2',
  //       value: LIST_OF_LINKS_MOCK_TEXT.H2_FULL_TEXT,
  //     }),
  //   );
  // }

  if (selectedTemplate === 3 || selectedTemplate === 5) {
    dispatch(actions.setBackgroundColor(colors));
  }
};
